import React, { useEffect, useState } from "react";
import moment from "moment";
import ContainerMasterDataTable from "../common/tables/ContainerMasterDataTable";
import { exportData } from "../../utils/helpers";
import { getContainerMasterData } from "../../services/ContainerMasterService";
import { FormatContainerMasterData } from "../../utils/dataFilter";
import store from "../../store/Store";
import * as actionType from "../../store/ActionTypes";
import { dispatcher } from "../../store/storeHelpers";
import { filter } from "lodash";
import Counters from "../common/Counters";
import noDataAvailable from "../../assets/img/noDataAvailable.png";
import { PulseLoader } from "react-spinners";
import {viewSIDoc, updateSIDoc } from "../../services/tractorDataService";

function ContainerMasterData() {
	const [loader, setLoader] = useState(false);
	const [data, setData] = useState([]);
	const [date, setDate] = useState({
		fromdate: moment().format("YYYY-MM-DD"),
		todate: moment().format("YYYY-MM-DD"),
	});
	// const [counterData, setCounterData] = useState([]);
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [getOutCounterData, setGetOutCounterData] = useState({
		GateOut: "",
		TotalGateOut: "",
	  });
	const resetStorage = () => {
		setData([]);
	};
	
	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setData(Object.values(store.getState().add_Container_Data));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (
			filter(userData, { MenuName: "Container Master", View: 1 }).length > 0
		) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Container Master", View: 1 })
			);
		}
	}, [userData]);

	useEffect(() => {
		async function getPlan() {
			resetStorage();
			setLoader(true);
			try {
				setNoDataState(false);
				const response = await getContainerMasterData(date, "ContainerMaster");
				dispatcher(
					actionType.CONTAINER_DATA_LOAD,
					FormatContainerMasterData(response.data)
				);
				setLoader(false);
			} catch (error) {
				setLoader(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
					setGetOutCounterData({
						GateOut: "",
						TotalGateOut: "",
					})
				}
			}
		}
		getPlan();
	}, [date]);

	const dataExportHandler = () => {
		exportData(
			data.map((item) => {
				
				return {
					
					Date: item["Date"] === "Invalid date" ? "" : item["Date"],
					
					Factory_In_Date:
						item["Gate_In_Date"] === "Invalid date" ? "" : item["Gate_In_Date"] ,
					
					Factory_In_Time:item["Gate_In_Time"]?new Date(`2000-01-01T${item["Gate_In_Time"]}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) : null,
					Factory_Out_Date:item["Gate_Out_Date"] === "Invalid date" ? "" : item["Gate_Out_Date"] ,
					
					Factory_Out_Time:item["Gate_Out_Time"]?new Date(`2000-01-01T${item["Gate_Out_Time"]}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) : null,
					invoice: item["invoice"],
					Total_Qty: item["T_qty"],
					Agg_Qty: item["A_qty"],
					Agg_Part: item["A_Part"],
					RFID_Seal_No: item["RFID_Seal_No"],
					Container_No: item["Container_Number"],
					Seal_No: item["Seal_No"],
					LR_NO: item["LR_NO"],
					Vehicle_No: item["Vehicle_No"],
					Carrier: item["Carrier"],
					Clearence: item["Clearence"],
					Dest_Country: item["Dest_Country"],
					Dest_Port: item["Dest_Port"],
					Final_Destination: item["final_destination_ConMaster"],
					Product: item["Product"],
					Booking_Number: item["Booking_Number"],
					Transporter: item["Transporter"],
					Pick_Up_Location: item["pick_up_location"],
					SAP_code: item["SAP_code"],
					Container_Type: item["Container_Type"],
					Driver_No: item["Driver_No"],
					Remark: item["Remarks"],
					Module: item["DataOf"],
				};
			}),
			`Container Master Data ${moment(date).format("DD-MM-YYYY")}`
		);
	};
	
	return (
		<>
			<div className="flex-row counterHeaderResponsive">
				<h1>Container Master</h1>
				<Counters
					counter={{ Total: getOutCounterData.TotalGateOut ? getOutCounterData.TotalGateOut.length : 0, Gate_Out: getOutCounterData.GateOut ? getOutCounterData.GateOut.length : 0}}
					label={["Total", "Gate_Out"]}
					styleData="df_dailyCounter"
				/>
			</div>
			{loader && (
				<PulseLoader
					color="#007bff"
					size="20px"
					margin="10px"
					style={{ position: "absolute", top: "50vh", left: "45%" }}
				/>
			)}
			{!loader && noDataState && (
				<img
					src={noDataAvailable}
					alt="notAvailableImg"
					className="noDataFoundImg"
					// style={{marginLeft:"-2%"}}
				/>
			)}
			{!loader && (
				<ContainerMasterDataTable
					tableData={data}
					setTableData={setData}
					date={date}
					setDate={setDate}
					dataExportHandler={dataExportHandler}
					subModule="Daily"
					type={"Daily"}
					filteredUserAccessData={filteredUserAccessData}
					noDataState={noDataState}
					setNoDataState={setNoDataState}
					setGetOutCounterData={setGetOutCounterData}
				/>
			)}
		</>
	);
}

export default ContainerMasterData;
